/**
 * The `tunnel` option for Sentry.init: the backend's tunnel on the API origin in production,
 * undefined elsewhere (no DSN is set outside production either).
 *
 * Trap: a relative `/api/sentry-tunnel` resolves against the portal's own origin (Cloudflare Pages),
 * which answers 405, so no browser event reaches Sentry. The tunnel lives on the API origin.
 */
export function getSentryTunnelUrl(mode: string, apiBaseUrl: string): string | undefined {
  if (mode !== 'production') {
    return undefined;
  }
  return `${apiBaseUrl.replace(/\/+$/, '')}/api/sentry-tunnel`;
}
